import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { ufActions } from '../../../application/actions/uf';

import api from '../../api';

const apiUfParams = api(process.env.REACT_APP_UF_API);

export function* fetchUfParams(action) {
  try {
    const { data } = yield call(apiUfParams.get, 'v1/consultar', action.payload);

    if (data) yield put(ufActions.fetchUfParamsSuccess(data));
    else yield put(ufActions.fetchUfParamsError());
  } catch (err) {
    yield put(ufActions.fetchUfParamsError());
  }
}

export function* watchFetchUf() {
  yield takeLatest(ufActions.fetchUfParams.type, fetchUfParams);
}

export default function* ufSaga() {
  yield spawn(watchFetchUf);
}
